'use strict';

require('./DropDown.scss');

const React = require('react'),
    {t} = require('services/i18nextWrapper'),
    ContentUtils = require('utils/ContentUtils'),
    ComponentUtils = require('utils/ComponentUtils'),
    get = require('lodash/object').get,
    { union } = require('lodash/array'),
    set = require('lodash/object').set,
    {PropTypes} = require('react'),
    TextField = require('components/Commons/TextField/TextField'),
    MenuList = require('components/Commons/MenuList/MenuList');

const ATTRIBUTE_ITEM_WITH_ICON = 'icon';
const ATTRIBUTE_ITEM_WITH_ICON_HTML = 'iconHTML';

const DropDown = React.createClass({displayName: "DropDown",
    propTypes: {
        name: PropTypes.string,
        readerAttribute: PropTypes.string,
        /**
         * The list of items of dropdown which have plain text or object.
         * In case which items are objects, we could add icons to each of item-object
         * have the name of class with the name of attribute
         *
         * (eg item: {icon: 'icon-task icon-task-yeast-in' ...} )
         */
        items: PropTypes.arrays,
        errorText: PropTypes.string,
        className: PropTypes.string,
        floatingLabelText: PropTypes.string,
        labelStyle: PropTypes.objec,
        errorStyle: PropTypes.object,
        onEnterKeyDown: PropTypes.func,
        onChange: PropTypes.func,
        onBlur: PropTypes.func,
        selectedIndex: PropTypes.object,
        disabled: PropTypes.bool,
        value: PropTypes.object,
        wrapperMenuItem: PropTypes.func,
        styleText: PropTypes.object,
        style: PropTypes.object,
        ref: PropTypes.func
    },

    getInitialState() {
        return {
            isExpanded: false,
            selectedItem: null,
            isPristine: true
        };
    },

    componentDidUpdate() {
        if (!this.isMounted()) { // avoid several problem of rendering when try to call 'refs' which are not mounted yet
            return;
        }
    },

    _onKeyDown(evt) {
        if (!evt) {
            return;
        }

        const isListExpanded = this.state.isExpanded;
        const isListCollapsed = !isListExpanded;

        const isPressedKeyArrowUp = evt.keyCode === 38;
        const isPressedKeyArrowDown = evt.keyCode === 40;
        const isPressedKeyEnter = evt.keyCode === 13;
        const isPressedKeyScape = evt.keyCode === 27;
        const isPressedKeyBackspace = evt.keyCode === 8;
        const isPressedKeyTab = evt.keyCode === 9;

        if (isPressedKeyArrowDown && isListCollapsed) {
            evt.preventDefault();
            this.onPressArrowDownAndListIsCollapsed();
        } else if (
            (isPressedKeyArrowDown || isPressedKeyArrowUp) &&
            isListExpanded
        ) {
            evt.preventDefault();
            this.onPressArrowUpOrDownArrow(
                isPressedKeyArrowUp,
                isPressedKeyArrowDown
            );
        } else if (isPressedKeyEnter) {
            evt.preventDefault();
            evt.stopPropagation();

            this.onPressEnter(evt);
        } else if (isPressedKeyScape || isPressedKeyBackspace) {
            evt.preventDefault();
            this.onPressScapeOrBackspace();
        }

        if (!isPressedKeyTab) {
            // just in case of any of before keys doesn't apply,
            // only allow tab key event bubbling as normal flow (not
            // prevent neither stop it). the Rest of actions need to be
            // stopped to simulate not-edition behavior of drop-down component.
            evt.preventDefault();
            evt.stopPropagation();
        }
    },

    onClickOutSide(event) {
        const targetEl = event && event.target;
        const innerText = get(event, 'target.innerText');
        const clickFromArrow = 'arrow_drop_down' === innerText;

        if (targetEl && !clickFromArrow) {
            // if clieck en label or input show not close dropdown
            const clickInnerLabel = targetEl.classList.contains('bp-textfield__label') || targetEl.classList.contains('bp-textfield__input');
            if (!clickInnerLabel) {
                const menuDropdownEl = ContentUtils.getComponentByClassName(targetEl, 'bp-menu-list');

                if (menuDropdownEl) {
                    this.collapseList();
                }
            }
        }
    },

    componentDidMount() {
        document.addEventListener('click', this.onClickOutSide);
    },

    componentWillUnmount() {
        document.removeEventListener('click', this.onClickOutSide, false);
    },

    onPressEnter(evt) {
        // select the first of the list
        const {onEnterKeyDown, items, onChange, readerAttribute, name} = this.props;
        const {isExpanded} = this.state;

        if (isExpanded) {
            const menuItems = buildItems(items, readerAttribute, name);
            const currentIndexSelected =
                evt && evt.target && evt.target.getAttribute('data-menu-index');
            const selectedItem = get(menuItems, currentIndexSelected);

            this.setState(
                {
                    selectedItem
                },
                () => {
                    this.focusInput();
                    this.collapseList();
                }
            );

            onChange(selectedItem, evt);

            if (onEnterKeyDown) {
                onEnterKeyDown(selectedItem);
            }
        }
    },

    getItemEl(index) {
        return this.getDOMNode().querySelector(
            `li[data-menu-index="${index}"]`
        );
    },

    onPressScapeOrBackspace() {
        this.collapseList();
        this.focusInput();
    },

    isEditMode() {
        return !!this.props.value;
    },

    expandList() {
        this.setState({ isExpanded: true });
    },

    collapseList() {
        this.setState({ isExpanded: false });
    },

    onPressArrowDownAndListIsCollapsed() {
        const {selectedItem} = this.state;

        this.setState({isExpanded: true}, () => {
            const firstItem = selectedItem
                ? this.getItemEl(get(selectedItem, 'payload')) // specific selected item
                : this.getDOMNode().querySelector('.bp-menu-list-item');

            if (firstItem) {
                firstItem.focus();
            }
        });
    },

    onPressArrowUpOrDownArrow(isPressedKeyArrowUp, isPressedKeyArrowDown) {
        // if the list is expanded, the client will
        // be able to walk through the list of
        // items which arrows keys (up & down)
        let activeElement = document.activeElement;
        const isFocusOutSideOfList = !activeElement.classList.contains(
            'bp-menu-list-item'
        );
        const {selectedItem} = this.state;

        if (isFocusOutSideOfList) {
            const firstItem = selectedItem
                ? this.getItemEl(selectedItem.payload)
                : this.getDOMNode().querySelector('.bp-menu-list-item');

            if (firstItem) {
                firstItem.focus();
            }
        } else if (isPressedKeyArrowUp) {
            const nextElement = activeElement.previousElementSibling;

            if (nextElement) {
                activeElement.previousElementSibling.focus();
            } else {
                this.collapseList();
                this.focusInput();
            }
        } else if (isPressedKeyArrowDown) {
            const nextElement = activeElement.nextElementSibling;

            if (nextElement) {
                if (activeElement.nextElementSibling) {
                    activeElement.nextElementSibling.focus();
                }
            }
        }
    },

    isListExpanded() {
        const { textWritten } = this.state;
        const isCurrentFocusSomeListItem =
            document.activeElement &&
            document.activeElement.classList.contains('bp-menu-list-item');
        return !!isCurrentFocusSomeListItem || !!textWritten;
    },

    focusInput() {
        this.getDOMNode().querySelector('input').focus();
    },

    getTextWritten() {
        return this.getDOMNode().querySelector('.bp-textfield input').value;
    },

    _onClick(evt) {
        if (evt && evt.preventDefault) {
            evt.preventDefault();
            evt.stopPropagation();
        }

        const { onClick } = this.props;

        this.setState(
            prevState => {
                return {
                    isExpanded: !prevState.isExpanded
                };
            },
            () => {
                if (onClick) {
                    onClick();
                }
            }
        );
    },

    _onChange(selectedItem, evt) {
        if (evt && evt.preventDefault) {
            evt.preventDefault();
            evt.stopPropagation();
        }
        const { onChange } = this.props;
        this.setState(
            {
                isExpanded: false,
                selectedItem
            },
            () => {
                this.focusInput();
                if (onChange) {
                    onChange(selectedItem, evt);
                }
            }
        );
    },

    _onBlur(evt) {
        evt.preventDefault();
        const { onBlur } = this.props;
        const { isExpanded, selectedItem } = this.state;

        if (onBlur && !isExpanded) {
            onBlur(selectedItem);
        }
    },

    getValue() {
        return this.state.selectedItem || this.props.value;
    },

    render() {
        const {
            floatingLabelText,
            items,
            errorText,
            errorStyle,
            className,
            readerAttribute,
            selectedIndex,
            disabled,
            labelStyle,
            style,
            name,
            wrapperMenuItem,
            key
        } = this.props;

        const menuItems = buildItems(items, readerAttribute, name, key);
        const { selectedItem, isExpanded } = this.state;
        const haveSelectedIndexDefined = selectedIndex > -1;
        const selectedItemByIndex = haveSelectedIndexDefined
            ? get(menuItems, selectedIndex)
            : null;
        const selectedIndexText = haveSelectedIndexDefined
            ? get(selectedItemByIndex, `itemModel.${readerAttribute}`)
            : '';

        // relay first internal state, (because is the latest state)
        // then check if was defined some initially
        const currentSelectedItemText = selectedItem
            ? get(selectedItem, `itemModel.${readerAttribute}`)
            : haveSelectedIndexDefined ? selectedIndexText : null;

        return (
            React.createElement("div", {
                id: "bp-dropdown-container", 
                onKeyDownCapture: disabled ? null : this._onKeyDown, 
                onClick: disabled ? null : this._onClick, 
                onBlur: disabled ? null : this._onBlur, 
                style: style, 
                className: `bp-drop-down${className
                    ? ' ' + className
                    : ''}${disabled ? ' is-disabled' : ''}`
            }, 
                React.createElement(TextField, {
                    floatingLabelText: floatingLabelText, 
                    icon: "arrow_drop_down", 
                    errorText: errorText, 
                    labelStyle: labelStyle, 
                    errorStyle: errorStyle, 
                    style: set(labelStyle, 'cursor', 'pointer'), 
                    value: currentSelectedItemText, 
                    disabled: disabled}
                ), 
                React.createElement(MenuList, {
                    readerAttribute: "text", // is already build it from this fixed property
                    readerAttributeIcon: "itemModel.iconClassName", 
                    customKey: key, 
                    items: menuItems, 
                    isExpanded: isExpanded, 
                    wrapperMenuItem: wrapperMenuItem, 
                    onChange: disabled ? null : this._onChange}
                )
            )
        );
    }
});

function buildItems(items, readerAttribute, name) {
    if (get(items, 'length', 0) > 0) {
        if (ContentUtils.isStringOrIntegerItem(items)) {
            return ComponentUtils.toMenuItemsText(items, name);
        } else {
            const nonSelectItem = [{payload: 0, text: `${t('label_select')} ${name}`}];
            return union(
                nonSelectItem,
                ComponentUtils.toMenuItems(items, readerAttribute, ATTRIBUTE_ITEM_WITH_ICON, 'bp-dropdown-item-index-', ATTRIBUTE_ITEM_WITH_ICON_HTML)
            );
        }
    } else {
        return [{payload: 0, text: `${t('label_select')} ${name}`}];
    }
}

module.exports = DropDown;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/DropDown/DropDown.js
 **/